import React from 'react'

import AuthForm from '../../components/auth/form'
import InvoiceOverlayModal from '../../components/modals'
import { useAuth } from '../../context/auth'
import { GuestPendingIntent } from '../../lib/guestInvoiceDraftStorage'

type Props = {
  open: boolean
  intent: GuestPendingIntent | null
  onClose: () => void
}

const intentTitles: Record<GuestPendingIntent, string> = {
  send: 'Sign in to send your invoice',
  viewPdf: 'Sign in to view your PDF',
}

const GuestSignInOverlay = ({ open, intent, onClose }: Props) => {
  const { signin, signInMicrosoft } = useAuth()
  const title = intent ? intentTitles[intent] : intentTitles.send

  return (
    <InvoiceOverlayModal open={open} onClose={onClose} modalClassName='invoice-client-modal--auth'>
      <AuthForm
        title={title}
        onGoogleSignIn={signin}
        onMicrosoftSignIn={signInMicrosoft}
        onBackClick={onClose}
      />
    </InvoiceOverlayModal>
  )
}

export default GuestSignInOverlay
